<app-navbar></app-navbar>
<div class="min-h-screen">
    <ng-template #paymentConfirmation>
        <h1 matDialogTitle>Payment Confirmation</h1>
        <div mat-dialog-content>Please complete the payment to proceed</div>
        <mat-dialog-actions>
            <button class="mb-3" mat-flat-button color="primary" matDialogClose="yes">Continue</button>
        </mat-dialog-actions>
    </ng-template>
    <ng-template #formDialog>
        <h1 matDialogTitle>Application Details</h1>
        <div mat-dialog-content>Please fill the application form to complete your booking.</div>
        <mat-dialog-actions>
            <button class="mb-3" mat-flat-button color="primary" matDialogClose="yes">Continue</button>
        </mat-dialog-actions>
    </ng-template>
    <ng-template #errorDialog>
        <h1 matDialogTitle>Page Expired</h1>
        <div mat-dialog-content>The page you're trying to access is no longer available.</div>
        <mat-dialog-actions>
            <button class="mb-3" mat-flat-button color="primary" matDialogClose="yes">Continue</button>
        </mat-dialog-actions>
    </ng-template>
</div>
<ngx-spinner bdColor="rgba(256, 256, 256, 0.5)" size="default" color="#c71d22" type="ball-spin-fade"
    [fullScreen]="true">
    <p style="color: white"> Please wait... </p>
</ngx-spinner>
<app-message></app-message>
<app-footer></app-footer>